import { render, staticRenderFns } from "./RisAdvance.vue?vue&type=template&id=95951798&scoped=true"
import script from "./RisAdvance.vue?vue&type=script&lang=js"
export * from "./RisAdvance.vue?vue&type=script&lang=js"
import style0 from "./RisAdvance.vue?vue&type=style&index=0&id=95951798&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95951798",
  null
  
)

export default component.exports